var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{'page-header': true, 'page-header-collapsed': _vm.collapsed}},[_c('div',{staticClass:"page-title-wrapper"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$route.meta.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7707f2fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Header/Header.vue
// module id = null
// module chunks = 